import { Link } from 'react-router';
import { MouseEventHandler } from 'react';

import { IProjectWithBlockchains } from 'domains/projects/types';
import { projectsRoutesConfig } from 'domains/projects/routes';

import { useProjectNamesStyles } from './useProjectNamesStyles';

export interface IProjectNamesProps {
  projects: IProjectWithBlockchains[];
}

const onLinkClick: MouseEventHandler = event => event.stopPropagation();

export const ProjectNames = ({ projects }: IProjectNamesProps) => {
  const { classes } = useProjectNamesStyles();

  return (
    <>
      {projects.map(({ name, userEndpointToken }) => {
        return (
          <Link
            className={classes.link}
            key={userEndpointToken}
            onClick={onLinkClick}
            title={name}
            to={projectsRoutesConfig.project.generatePath(userEndpointToken)}
          >
            <span className={classes.name}>{name}</span>
          </Link>
        );
      })}
    </>
  );
};
